module.exports = __webpack_public_path__ + "img/grp-part-8-option-3.ae3ed205.png";